import { FormDefinition } from "../../Components/Form/Form";
import { basic_text_validator, boolean_selection_validator, email_validator, selection_validator, unique_email_validator } from "../formFieldValidators";

export const adminProfileFormDefinition: FormDefinition = {
  firstName: {
    label: "First Name",
    frLabel: "Prénom",
    inputType: "text",
    validator: {
      fieldType: "text",
    }
  },
  lastName: {
    label: "Last Name",
    frLabel: "Nom de famille",
    inputType: "text",
    validator: {
      fieldType: "text",
    }
  },
  email: {
    label: "Email",
    frLabel: "",
    inputType: "text",
    validator: email_validator,
  }
}

export const createAdminProfileFormDefinition: FormDefinition = {
  firstName: {
    label: "First Name",
    frLabel: "Prénom",
    inputType: "text",
    validator: basic_text_validator,
  },
  lastName: {
    label: "Last Name",
    frLabel: "Nom de famille",
    inputType: "text",
    validator: basic_text_validator,
  },
  uniqueEmail: {
    label: "Email",
    frLabel: "Courrier",
    inputType: "text",
    validator: unique_email_validator,
  },
  userRegion: { 
    label: "Select Admin Organization",
    frLabel: "Sélectionner Organisation/Admin",
    inputType: "dropdownSelect",
    validator: {
      required: {
        value: true,
        message: "Please select an option"
      }
    },
    additionalData: {
      selectionData: [
        {
          value: "communitech", 
          text: "Communitech"
        },
        {
          value: "northForge", 
          text: "North Forge"
        },
        {
          value: "investOttawa", 
          text: "Invest Ottawa"
        }
      ]
    }
  },
}


export const helpFormDefition: FormDefinition = {
  helpCategory: {
    label: "What do you need help with?",
    frLabel: "De quoi avez-vous besoin?",
    inputType: "dropdownSelect",
    placeholder: "Select a category",
    frPlaceholder: "Sélectionnez une catégorie",
    validator: { required: { value: true, message: "Please select a category", frMessage: "Veuillez sélectionner une catégorie" } },
    additionalData: {
      selectionData: [
        { value: "applicationStatus", text: "Check Application Status", frText: "Vérifier l'état de la demande" },
        { value: "portalUsage", text: "How to Use the Portal", frText: "Comment utiliser le portail" },
        { value: "portalIssue", text: "Report a Portal Issue", frText: "Signaler un problème du portail" },
        { value: "other", text: "Other", frText: "Autre" },
      ]
    }
  },
  message: {
    label: "Message",
    frLabel: "Message",
    inputType: "textarea",
    placeholder: "Type your message here...",
    frPlaceholder: "Saisissez votre message ici...",
    validator: basic_text_validator
  }
}


export const contactUsFormDefinition: FormDefinition = {
  email: {
    label: "Your Email",
    frLabel: "Votre Courriel",
    placeholder: "Your email address",
    frPlaceholder: "Votre adresse courriel",
    inputType: "text",
    validator: email_validator
  },
  subject: {
    label: "Name",
    frLabel: "Nom",
    placeholder: "Your full name",
    frPlaceholder: "Votre nom complet",
    inputType: "text",
    validator: basic_text_validator
  },
  message: {
    label: "Message",
    frLabel: "Message",
    placeholder: "Type your message here...",
    frPlaceholder: "Saisissez votre message ici...",
    inputType: "textarea",
    validator: basic_text_validator
  }
}


export const adminRecommendationFormDefition: FormDefinition = {
  rec: {
    label: "Recommendation:",
    inputType: "textarea",
    validator: basic_text_validator,
  },
  tierRec: {
    label: "Recommended Service Tier:",
    inputType: "text",
    validator: basic_text_validator,
  }
}


export const gcRejectFormDefinition: FormDefinition = {
  reasonNote: {
    label: "Please Provide A Reason for Rejecting this Application:",
    inputType: "textarea",
    validator: basic_text_validator,
    tooltip: {
      content: "This note will be visible to the startup",
    },
  }
}


export const customEmailFormDefinition: FormDefinition = {
  customMessage: {
    label: "Please Write Custom Message for Email Body:",
    inputType: "textarea",
    validator: basic_text_validator,
    tooltip: {
      content: "Please note greeting based on company's contact info and thank you/sign off is included in the email template, please only include the body of the email",
    },
  },
  respondTo: {
    label: "If a response is required, please provide an email to which the company may respond.",
    inputType: "text",
    tooltip: {
      content: "If no email is provided the general ElevateIP email is provided to receive response in the automated email.",
      position: "bottom-left"
    },
    validator: {
      ...email_validator,
      required: false
    }
  }
}


export const ddFormDef: FormDefinition = {
  cat1: {
    label: "Cat1",
    inputType: "boolean",
    validator: boolean_selection_validator,
  },
  cat2: {
    label: "Cat2",
    inputType: "boolean",
    validator: boolean_selection_validator,
  },
  cat3: {
    label: "Cat3",
    inputType: "boolean",
    validator: boolean_selection_validator,
  },
  cat4: {
    label: "Cat4",
    inputType: "boolean",
    validator: boolean_selection_validator,
  },
  cat5: {
    label: "Cat5",
    inputType: "boolean",
    validator: boolean_selection_validator,
  },
  cat6: {
    label: "Cat6",
    inputType: "boolean",
    validator: boolean_selection_validator,
  },
}


export const auditOutcomeForm: FormDefinition = {
  auditNote: {
    label: "Please provide a note regarding your decision",
    frLabel: "Nom du service",
    inputType: "text",
    validator: basic_text_validator
  },
}
